import { assetIsSvg } from "@/lib/storyblok/assetHelpers";
import type { AssetStoryblok } from "@/types/blok-types";

const Asset = ({ asset }: { asset: AssetStoryblok }): React.JSX.Element => {
  if (assetIsSvg(asset)) {
    return <object data={asset.filename} />;
  }
  return <span>{asset.filename}</span>;
};

export default Asset;
